<template>
  <transition name="el-fade-in-linear">
    <div class="about">
     <img class="aboutFirstLevelBack" src="../../static/images/about.png">
      <div class="aboutFirstLevel">
        <div class="aboutFirstLevelItem">
          <div class="aboutFirstLevelItemText">关于我们</div>
          <div class="aboutFirstLevelItemText1">对创新的热情</div>
          <div class="aboutFirstLevelItemText1">燃烧不尽</div>
          <div class="line"></div>
        </div>
        <div class="aboutFirstLevelItem1 videoItem">
          <video poster="../../static/video/logoVideo.png" controls>
            <source
              src="http://www.szbit.cn/videos/szbit-video.mp4"
              type="video/mp4"
            />
          </video>
        </div>
      </div>
      <div class="aboutSecondLevel">
      <div class="aboutSecondLevelTitle1">北斗院</div>
      <div class="aboutSecondLevelTitle2">深圳北斗应用技术研究院有限公司</div>
      <div class="aboutSecondLevelText">
        是中国科学院深圳先进技术研究院于2014年9月成立的面向人工智能应用领域的专业型研发机构。北斗院致力于打造大交通行业的智能决策引擎，通过融合大数据、人工智能等技术，贯通交通组织感知-认知-决策-反馈的自适应闭环，助推产业智能化升级，实现安全、高效、可持续发展。
      </div>
      </div>

      <img class="aboutPic1" src="../../static/images/aboutPic1.png" />
      <br />
      <img class="aboutPic2" src="../../static/images/aboutPic2.png" />
      <div class="road">
        <div class="roadText">
          <div class="roadTextYear">2012</div>
          <ul class="roadTextUl">
            <li class="roadTextLiNormal">
              孙家栋等三位院士来先进院参加“北斗位置云研讨会”，提出建设设想
            </li>
            <li class="roadTextLiNormal">
              获批“深圳市北斗位置服务技术工程实验室”，开始人员和技术积累
            </li>
          </ul>
        </div>
        <div class="roadText" style="display: none">
          <div class="roadTextYear">2013</div>
          <ul class="roadTextUl">
            <li class="roadTextLiNormal">
              “深圳北斗应用技术研院”2013年高交会正式揭牌成立
            </li>
          </ul>
        </div>

        <div class="roadText" style="display: none">
          <div class="roadTextYear">2014</div>
          <ul class="roadTextUl">
            <li class="roadTextLiNormal">
              “深圳北斗应用技术研究院有限公司”正式工商注册
            </li>
            <li class="roadTextLiNormal">“电子站牌”上线运营</li>
            <li class="roadTextLiNormal">“数说交通”开播</li>
            <li class="roadTextLiNormal">
              《基于云环境的城市综合交通信息集成与服务关键技术及应用》获中国智能交通协会科学技术一等奖
            </li>
          </ul>
        </div>
        <div class="roadText" style="display: none">
          <div class="roadTextYear">2015</div>
          <ul class="roadTextUl">
            <li class="roadTextLiNormal">
              《城市大数据分析平台及服务》项目获得深圳市科创委“创新创业资助”
            </li>
            <li class="roadTextLiNormal">
              获得广东省经济和信息化委“广东省大数据应用示范项目”荣誉
            </li>
            <li class="roadTextLiNormal">
              获得“中国小谷围互联网运输服务创客大赛”三等奖
            </li>
            <li class="roadTextLiNormal">
              受深圳市城市管理局聘请为深圳市智慧城管战略发展顾问
            </li>
          </ul>
        </div>
        <div class="roadText" style="display: none">
          <div class="roadTextYear">2016</div>
          <ul class="roadTextUl">
            <li class="roadTextLiNormal">智慧宝安中央控制平台开建</li>
            <li class="roadTextLiNormal">
              与深圳巴士集团、滴滴出行共同投资成立“滴滴优点”公司
            </li>
            <li class="roadTextLiNormal">华为物流调度算法上线</li>
            <li class="roadTextLiNormal">深圳地铁“TOS系统”上线</li>
            <li class="roadTextLiNormal">
              入选中国智能交通协会智能交通推荐单位
            </li>
          </ul>
        </div>
        <div class="roadText" style="display: none">
          <div class="roadTextYear">2017</div>
          <ul class="roadTextUl">
            <li class="roadTextLiNormal">“优点巴士”获得滴滴出行战略投资</li>
            <li class="roadTextLiNormal">
              深圳公安公共交通安全立体防控系统开建
            </li>
            <li class="roadTextLiNormal">
              取得国家高新技术企业、深圳市国家高新技术企业认定
            </li>
            <li class="roadTextLiNormal">
              获得“粤治-治理现代化2016-2017年优秀案例”荣誉
            </li>
            <li class="roadTextLiNormal">获得“广东省新型研发机构”的荣誉</li>
          </ul>
        </div>
        <div class="roadText" style="display: none">
          <div class="roadTextYear">2018</div>
          <ul class="roadTextUl">
            <li class="roadTextLiNormal">无锡地铁站台防控综合平台开建</li>
            <li class="roadTextLiNormal">与腾讯云、紫光云签署战略合作协议</li>
            <li class="roadTextLiNormal">
              上海临港下一代智能交通控制网示范工程研究与规划服务中标
            </li>
            <li class="roadTextLiNormal">广州公安公共交通反恐应用平台中标</li>
            <li class="roadTextLiNormal">
              深圳公安公共交通安全立体防控系统上线并取得显著效果
            </li>
          </ul>
        </div>
        <div class="roadText" style="display: none">
          <div class="roadTextYear">2019</div>
          <ul class="roadTextUl">
            <li class="roadTextLiNormal">组建了市场团队，全国快速扩张元年</li>
            <li class="roadTextLiNormal">
              获得第一个智慧机场——深圳宝安机场订单
            </li>
            <li class="roadTextLiNormal">
              参加联合国教科文组织智慧城市论坛，并做主题发言
            </li>
            <li class="roadTextLiNormal">通过CMMI能力成熟度模型三级的认证</li>
            <li class="roadTextLiNormal">
              《国际化枢纽城市智慧场站运行管控关键技术与应用》获得中国智能交通协会科学技术奖三等奖
            </li>
            <li class="roadTextLiNormal">
              科技部重点研发计划“互联网+政务大数据透明管理及智能服务平台”成功获批
            </li>
          </ul>
        </div>
        <div class="roadText" style="display: none">
          <div class="roadTextYear">2020</div>
          <ul class="roadTextUl">
            <li class="roadTextLiNormal">
              基于城市交通大数据分析与推演技术及时发布疫情跟踪排查系统，受到深圳卫视等媒体广泛报道
            </li>
            <li class="roadTextLiNormal">
              自主研发的“公共交通一体化智慧监测系统”斩获德国红点奖
            </li>
          </ul>
        </div>
      </div>
      <!--
      <div class="roadLine0"></div>
      -->
      <div class="roadLine">
        <div class="roadPointerLayout" @click="changeYear($event, 1)">
          <div class="roadSilder silderPosition1">
            <span class="roadPointer pointerPosition1"> </span>
          </div>
          <span class="roadSpanText roadSpanTextPosition1">2012</span>
        </div>
        <div class="roadPointerLayout" @click="changeYear($event, 2)">
          <div class="roadSilder silderPosition2">
            <span class="roadPointer pointerPosition2"> </span>
          </div>
          <span class="roadSpanText roadSpanTextPosition2">2013</span>
        </div>
        <div class="roadPointerLayout" @click="changeYear($event, 3)">
          <div class="roadSilder silderPosition3">
            <span class="roadPointer pointerPosition3"> </span>
          </div>
          <span class="roadSpanText roadSpanTextPosition3">2014</span>
        </div>
        <div class="roadPointerLayout" @click="changeYear($event, 4)">
          <div class="roadSilder silderPosition4">
            <span class="roadPointer pointerPosition4"> </span>
          </div>
          <span class="roadSpanText roadSpanTextPosition4">2015</span>
        </div>
        <div class="roadPointerLayout" @click="changeYear($event, 5)">
          <div class="roadSilder silderPosition5">
            <span class="roadPointer pointerPosition5"> </span>
          </div>
          <span class="roadSpanText roadSpanTextPosition5">2016</span>
        </div>
        <div class="roadPointerLayout" @click="changeYear($event, 6)">
          <div class="roadSilder silderPosition6">
            <span class="roadPointer pointerPosition6"> </span>
          </div>
          <span class="roadSpanText roadSpanTextPosition6">2017</span>
        </div>
        <div class="roadPointerLayout" @click="changeYear($event, 7)">
          <div class="roadSilder silderPosition7">
            <span class="roadPointer pointerPosition7"> </span>
          </div>
          <span class="roadSpanText roadSpanTextPosition7">2018</span>
        </div>
        <div class="roadPointerLayout" @click="changeYear($event, 8)">
          <div class="roadSilder silderPosition8">
            <span class="roadPointer pointerPosition8"> </span>
          </div>
          <span class="roadSpanText roadSpanTextPosition8">2019</span>
        </div>
        <div class="roadPointerLayout" @click="changeYear($event, 9)">
          <div class="roadSilder silderPosition9">
            <span class="roadPointer pointerPosition9"> </span>
          </div>
          <span class="roadSpanText roadSpanTextPosition9">2020</span>
        </div>
      </div>

      <div class="aboutContact">
        <img
          class="aboutContactTitle"
          src="../../static/images/contactus.png"
        />
        <!--
        <div class="aboutContactTitle">Contact us</div>
        -->
        <div class="aboutContactRelative">联系我们</div>
        <div class="aboutLine"></div>
        <div class="aboutNumber">0755-86539692</div>
        <div class="aboutContactText">网址：www.sibat.cn</div>
        <div class="aboutContactText">商务合作：info@szbit.cn</div>
        <div class="aboutContactText">简历投递：hr@szbit.cn</div>
        <div class="aboutContactText">
          地址：深圳市南山区创科路深圳国际创新谷1期2栋A座22楼
        </div>
      </div>
      <div class="aboutFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>


<script>
import Foot from "./Foot";

export default {
  name: "Index",
  data() {
    return {};
  },
  mounted: function () {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  components: {
    Foot,
  },
  methods: {
    changeYear(evt, index) {
      //console.log("index", index);

      let i, tablinks, pointer;
      tablinks = document.getElementsByClassName("roadText");
      for (i = 0; i < tablinks.length; i++) {
        if (i != index - 1) {
          tablinks[i].style.display = "none";
        } else {
          tablinks[i].style.display = "inline";
        }
      }
      pointer = document.getElementsByClassName("roadSilder");
      //console.log("pointer:", pointer[0].className);
      for (i = 0; i < pointer.length; i++) {
        if (i != index - 1) {
          pointer[i].className = pointer[i].className.replace(
            "roadSilderActive",
            "roadSilder"
          );
        } else {
          pointer[i].className += " roadSilderActive";
        }
      }

      let minpointer = document.getElementsByClassName("roadPointer");
      //console.log("minpointer:", minpointer[0].className);
      for (i = 0; i < minpointer.length; i++) {
        if (i != index - 1) {
          minpointer[i].className = minpointer[i].className.replace(
            "roadPointerActive",
            "roadPointer"
          );
        } else {
          minpointer[i].className += " roadPointerActive";
        }
      }
      //evt.currentTarget.className += " active";
    },
  },
};
</script>
<style scoped>
@import "./About.css";
</style>



// WEBPACK FOOTER //
// src/views/About.vue